import { useFpCampaignCoupons } from '@cart-services/hooks/useFpCampaignCoupons'
import { useFpCampaignProductCatalogProducts } from '@cart-services/hooks/useFpCampaignProductCatalogProducts'
import { CategoryProductsFilter } from '@cart-ui/CategoryProductsFilter/CategoryProductsFilter'
import { useCategoryProductsFilter } from '@cart-ui/CategoryProductsFilter/useCategoryProductsFilter'
import { DiscountTips } from '@cart-ui/DiscountTips/DiscountTips'
import { useFastpassCampaignGoogleAnalyticEvent } from '@dni-analysis'
import { Box } from '@pets-ui/Box/Box'
import { Divider } from '@pets-ui/Divider/Divider'
import { Paper } from '@pets-ui/Paper/Paper'
import { Text } from '@pets-ui/Text/Text'
import { VStack } from '@pets-ui/VStack/VStack'
import { CollapseProduct } from '../CollapseProduct/CollapseProduct'
import { useProductCatalog } from '../ProductCatalogProvider/useProductCatalog'

export const CategoryProducts = ({ category }: { category: string }) => {
  const { campaignId, projectCode, countryCode, currency, campaignCode } = useProductCatalog()
  const { productCatalogDto } = useFpCampaignProductCatalogProducts(projectCode, campaignCode)
  const { getMergedCouponCriterions } = useFpCampaignCoupons(campaignId, countryCode, campaignCode)
  const { currentCategoryProducts, isFilteredByCoupon, toggleFilterByCoupon } = useCategoryProductsFilter(category, productCatalogDto)

  const mergedCouponCriterions = getMergedCouponCriterions(currentCategoryProducts.coupon_ids || [])
  const couponIds = currentCategoryProducts?.coupon_ids || []

  const { sendPromotionFilterEvent } = useFastpassCampaignGoogleAnalyticEvent({ projectCode, countryCode, campaignId })

  const handleDisplayCouponProducts = () => {
    toggleFilterByCoupon()
    sendPromotionFilterEvent()
  }

  return (
    <VStack gap={2}>
      {couponIds.length > 0 && <DiscountTips mergedCouponCriterions={mergedCouponCriterions} currency={currency} />}
      <Paper elevation={0} height="100%" position="relative" borderRadius={8}>
        <CategoryProductsFilter
          isFilteredByCoupon={isFilteredByCoupon}
          handleFilterByCouponClick={handleDisplayCouponProducts}
        />
        <Divider />
        <VStack py={2} gap={2} divider={<Divider />}>
          {currentCategoryProducts?.all_product?.map(
            parentProductGroup => (
              <CollapseProduct
                key={parentProductGroup.id}
                parentProductGroup={parentProductGroup}
                projectCode={projectCode}
                countryCode={countryCode}
              />
            ),
          )}
          <Box pl={2}>
            {currentCategoryProducts?.all_product?.length === 0 && <Text>沒有活動商品</Text>}
          </Box>
        </VStack>
      </Paper>
    </VStack>
  )
}
